<div class="rvshare-windows-modal-container">
  <div class="rvshare-windows-modal-text">
    <div class="platform-badge">
      <mat-icon aria-hidden="true" svgIcon="integration-microsoft"></mat-icon>
      For Windows
    </div>
    <h3 [id]="titleId" class="tw-m-0">Get Rise Vision Share for Windows</h3>
    <p class="intro">
      Install the free <b>Rise Vision Share</b> app to unlock seamless sharing
      and remote interactive controls:
    </p>
    <ul class="feature-list">
      @for (feature of features; track feature.title) {
        <li>
          <mat-icon aria-hidden="true" svgIcon="check-filled"></mat-icon>
          <div class="feature-text">
            <span class="feature-title">{{ feature.title }}</span>
            <span class="feature-description">{{ feature.description }}</span>
          </div>
        </li>
      }
    </ul>
    <div class="links-row">
      <span
        >Already Installed?
        <button type="button" class="link-button" (click)="launchApp()">
          Launch app
        </button></span
      >
      <span aria-hidden="true" class="separator">•</span>
      <a class="link-button" target="_blank" [href]="helpGuideUrl"
        >View help guide</a
      >
    </div>
    @if (launchFailed) {
      <p class="launch-error" role="alert">
        App couldn't be opened. Please download below.
      </p>
    }
    <div class="actions-row">
      <button rv-button variant="secondary" type="button" (click)="dismiss()">
        Not now
      </button>
      <button rv-button type="button" (click)="download()">
        <mat-icon aria-hidden="true" svgIcon="download"></mat-icon>
        Download for Windows
      </button>
    </div>
  </div>
  <div class="rvshare-windows-modal-graphic">
    <img
      src="/images/screen-sharing/rvshare-windows.png"
      width="448"
      height="560"
      alt=""
    />
  </div>
  <button
    type="button"
    class="close-button"
    (click)="dismiss()"
    aria-label="Click to close this modal"
  >
    <mat-icon aria-hidden="true" svgIcon="close"></mat-icon>
  </button>
</div>
